import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import {
  RiaLiterature,
  FundLiterature,
  FormsAndApplications,
  IntervalFundsContainer,
  InvestorLogin,
  VariableFunds,
  MutualFundsContainer,
  ExchangeTradedFunds,
  ModelPortfoliosContainer,
  ClosedEndFundsContainer,
  FutureScholarPortfolios,
  SearchList,
} from '..'

export function SimpleEntryComponent({ component }) {
  const [reactComponent, setReactComponent] = useState(null)

  const componentsMap = {
    InvestorLogin: InvestorLogin,
    RiaLiterature: RiaLiterature,
    IntervalFundsContainer: IntervalFundsContainer,
    FundLiterature: FundLiterature,
    FormsAndApplications: FormsAndApplications,
    VariableFunds: VariableFunds,
    MutualFundsContainer: MutualFundsContainer,
    ExchangeTradedFunds: ExchangeTradedFunds,
    ModelPortfoliosContainer: ModelPortfoliosContainer,
    ClosedEndFundsContainer: ClosedEndFundsContainer,
    FutureScholarPortfolios: FutureScholarPortfolios,
    SearchList: SearchList,
  }

  useEffect(() => {
    setReactComponent(component?.getParameters().reactComponent)
  }, [reactComponent])

  const ReactComponent = componentsMap[reactComponent]

  return ReactComponent ? <ReactComponent /> : null
}

SimpleEntryComponent.propTypes = {
  component: PropTypes.object,
}
